
<template>
	<div class="">
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Invoice Procces" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
					<button
						type="button"
						class="btn btn-primary btn-with-shadow"
						@click="openAddEditModal"
					>
						Invoice Procces
					</button>
				</div>
			</div>
		</div>
		<app-table :id="tableId" :options="options" @action="getListAction" />
        <invoice-history-table-form
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:form-id="formId"
			:value="value"
			:row-data="rowData"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/>
		
		<app-delete-modal 
			v-if="deleteConfirmationModalActive" 
			:preloader="deleteLoader" 
			modal-id="demo-delete" 
			@confirmed="confirmed" 
			@cancelled="cancelled" 
		/>

        <!-- <app-confirm-modal
			v-if="confirmModalApprove"
			modal-id="confirm-approve-reject"
			:preloader="confirmLoader"
			:title="confirmAction === 'approve' ? 'Confirm Approval' : 'Confirm Rejection'"
			:message="confirmAction === 'approve'
				? 'Are you sure you want to APPROVE this invoice?'
				: 'Are you sure you want to REJECT this invoice?'"
			:icon="confirmAction === 'approve' ? 'check-circle' : 'alert-triangle'"
			:modal-class="confirmAction === 'approve' ? 'success' : 'warning'"
			:first-button-name="'Continue'"
			:second-button-name="'Cancel'"
			@confirmed="confirmedApproveReject"
			@cancelled="cancelConfirm"
		/> -->


        <invoice-history-approve-form
			v-if="confirmModalApprove"
			:table-id="tableId"
			:form-id="formIdApprove"
			:confirmInvoiceId="Number(confirmInvoiceId)"
			:value="value"
			:row-data="rowData"
			:selected-url="selectedUrl"
			@close-modal="cancelConfirm"
		/>
        <invoice-history-reject-form
			v-if="confirmModalReject"
			:table-id="tableId"
			:form-id="formIdReject"
			:confirmInvoiceId="Number(confirmInvoiceId)"
			:value="value"
			:row-data="rowData"
			:selected-url="selectedUrl"
			@close-modal="cancelConfirmReject"
		/>
        
		<modal-view-p-d-f
			v-if="showPDF"
			:selected-url="pdfUrl"
			@close-modal="closeModalViewPdf"
		/>

	</div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import { Schema } from "./Schema";
import { urlGenerator } from "../../../../Helpers/AxiosHelper";
import { INVOICE_HISTORY_V2 } from "../../../../Config/ApiUrl";
import ModalViewPDF from "./ModalViewPDF.vue";

export default {
	components: {
		ModalViewPDF,
	},
	extends: CoreLibrary,
	name: "InvoiceHistoryTable",
	inject: ["eventHub"],
	mixins: [Schema],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
    data() {
		return {
			preloader: false,
			showPDF: false,
			inputs: {},
			modalId: this.formId,
			modalTitle: this.$t("add"),
					
			confirmAction: null,
			confirmInvoiceId: null,
			confirmModalApprove: false,
			confirmModalReject: false,
			confirmLoader: false,
		};
	},
	created() {
		this.options.columns = [...this.tableColumns/*, this.actionObj*/];
	},
	mounted() {
		window.__approveInvoice = (id) => {
			this.handleApprove(id);
		};
		window.__rejectInvoice = (id) => {
			this.handleReject(id);
		};
	},
	methods: {
		/**
		 * for open add edit modal
		 */
		
		closeModalViewPdf() {
			this.showPDF = false;
		},
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},
        
		closeAddEditModal() {
			$("#invoice-history-table-form").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;

			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				
				window.location.href = `/transaction/profile-student/invoice/invoice-request-v2/`+rowData.id;
				
			} else if (actionObj.title == this.$t("Duplicate Invoice")) {
				axios
					.post(`/transaction/invoice/${rowData.id}/duplicate`)
					.then((res) => {
						this.$hub.$emit("reload-" + this.tableId);
						this.$toastr.s(res.data.message);
					})
					.catch((err) => {
						this.$hub.$emit("reload-" + this.tableId);
						this.$toastr.e(err.response.data.message);
					});
			}else if (actionObj.title == 'Print') {
				window.location.href = `/transaction/profile-student/invoice-v2/invoice-process/pdf/`+rowData.id;
			}else if (actionObj.title == 'View') {
                this.pdfUrl = `/transaction/invoice-request/viewPDF/${rowData.id}`;
                this.showPDF = true;
			} else if (
				actionObj.title != "Delete" ||
				actionObj.title != this.$t("edit")
			) {
				this.selectedUrl = INVOICE_HISTORY_V2 + "/" + rowData.id;
				// this.openAddEditModal();
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			// let url = `${this.Endpoint}/${this.rowData.id}`;
			let url = INVOICE_HISTORY_V2 + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},

		/**
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},
		reloadTable() {
			this.$hub.$emit("reload-" + this.tableId);
		},
		handleApprove(id) {
			this.confirmAction = "approve";
			this.confirmInvoiceId = Number(id);
			this.confirmModalApprove = true;
		},
		handleReject(id) {
			this.confirmAction = "reject";
			this.confirmInvoiceId = Number(id);
			this.confirmModalReject = true;
		},
		confirmedApproveReject() {

			let url = "";
			if (this.confirmAction === "approve") {
				url = `/transaction/invoice-v2/${this.confirmInvoiceId}/approve`;
			} else if (this.confirmAction === "reject") {
				url = `/transaction/invoice-v2/${this.confirmInvoiceId}/reject`;
			}

			this.confirmLoader = true;
			axios.post(url)
				.then((res) => {
					this.$hub.$emit("reload-" + this.tableId);
					this.$toastr.s(res.data.message);
				})
				.catch((err) => {
					this.$toastr.e(err.response?.data?.message || "Action failed");
				})
				.finally(() => {
					this.confirmLoader = false;
					this.cancelConfirm();
					this.confirmModalApprove = false;
      				this.removeBackdrop(); 
				});
		},

		cancelConfirm() {
			this.confirmModalApprove = false;
			this.confirmAction = null;
			this.confirmInvoiceId = null;
  			this.removeBackdrop(); 
		},
		cancelConfirmReject() {
			this.confirmModalReject = false;
			this.confirmAction = null;
			this.confirmInvoiceId = null;
  			this.removeBackdrop(); 
		},
		removeBackdrop() {
			document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
			document.body.classList.remove('modal-open'); // kalau body masih ke-lock scroll
			document.body.style = ""; // reset style
		},


	},
};
</script>

<style scoped>
	::v-deep(.datatable-th) {
		z-index: 10;
		position: relative;
	}
	::v-deep(.pt-primary ) {
		padding-top: 0 !important;
	}
</style>